






import _ from 'lodash'
import moment from 'moment'
import { Vue, Component, Prop } from 'vue-property-decorator'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { IPatient, IPatientType } from '@/store/modules/views/patient/states'
import Getter from '@/decorator/Getter'

@Component
export default class PatientDetail extends VueExtendedBaseComponent {
  @Prop({ default: () => ({}) }) public detail!: IPatient

  @Getter('patient/patientTypeById')
  private patientTypeById!: {[patientTypeId: string]: IPatientType}

  get profile() {
    return this.detail
      ? {
          title: 'ประวัติ',
          icon: 'account',
          data: _.filter([
            { text: 'ชื่อ นามสกุล', value: this.mapFullName(this.detail) },
            {
              text: 'วัน/เดือน/ปีเกิด',
              value: this.detail.birthdate ? this.doConvertDate(this.detail.birthdate) : '',
            },
            // { text: 'หมายเลขบัตรประชาชน', value: this.detail.idCard },
            {
              text: 'เบอร์โทรศัพท์มือถือ',
              value: this.detail.phone,
              click: () => this.telPhone(this.detail.phone),
            },
            {
              text: 'เบอร์โทรศัพท์มือถือญาติ',
              value: this.detail.sosPhone,
              click: () => this.telPhone(this.detail.sosPhone),
            },
            {
              text: 'ที่อยู่',
              value: this.detail.address ? this.mapAddress(this.detail.address) : '',
            },
            {
              text: 'ประเภท',
              value: this.patientTypeById[this.detail.patientTypeId]
                ? this.patientTypeById[this.detail.patientTypeId].name
                : '',
            },
            // { text: 'โรงพยาบาล/คลินิคที่รักษาปัจจุบัน', value: this.detail.hospital },
            { text: 'โรคประจำตัว', value: this.detail.disease },
            { text: 'การแพ้ยา', value: this.detail.drugAllergy },
          ], (item) => item.value !== ''),
        }
      : {}
  }

  get patientHealthy() {
    return this.detail && this.detail.metadata
      ? {
          title: 'ข้อมูลสิทธิด้านสุขภาพเฉพาะตัว',
          icon: 'account-key',
          data: _.filter([
            {
              text: 'สิทธิการรักษา',
              value: this.detail.metadata.patientHealthyMedicalTreatmentOther
                ? this.detail.metadata.patientHealthyMedicalTreatmentOther
                : this.detail.metadata.patientHealthyMedicalTreatment,
            },
            {
              text: 'ความสัมพันธ์',
              value: this.detail.metadata.patientHealthyCaretakerRelationOther
                ? this.detail.metadata.patientHealthyCaretakerRelationOther
                : this.detail.metadata.patientHealthyCaretakerRelation,
            },
          ], (item) => item.value !== ''),
        }
      : {}
  }

  get physicalExamination() {
    return this.detail && this.detail.metadata
      ? {
          title: 'การตรวจร่างกาย',
          icon: 'thermometer-lines',
          data: _.filter([
            { text: 'น้ำหนัก', value: `${this.detail.metadata.physicalExaminationWeight || '-'} กก.` },
            { text: 'ส่วนสูง', value: `${this.detail.metadata.physicalExaminationHeight || '-'} ซม.` },
            { text: 'รอบเอว', value: `${this.detail.metadata.physicalExaminationWaistline || '-'} ซม.` },
            {
              text: 'อุณหภูมิ',
              value: `${this.detail.metadata.physicalExaminationTemperature || '-'} องศาเซลเซียส`,
            },
            { text: 'อัตรการเต้นของหัวใจ', value: `${this.detail.metadata.physicalExaminationHeartRate || '-'} ครั้ง/นาที` },
            {
              text: 'ความดันโลหิต',
              value: `${this.detail.metadata.physicalExaminationBloodPressure || '-'} มม. ปรอท`,
            },
          ], (item) => item.value !== ''),
        }
      : {}
  }

  get history() {
    let history = []
    if (this.detail && this.detail.metadata) {
      _.forEach(
        _.filter(this.detail.metadata.historyDisease, (historyDisease) => historyDisease.disease),
        (item, index) => {
          history = history.concat(this.doTransformHistory(item, index + 1))
        },
      )
    }
    return {
      title: 'ประวัติการเจ็บป่วยและการรักษาโรค',
      icon: 'hospital-building',
      data: history,
    }
  }

  get medicationLongTerm() {
    const medicationLongTerm = []
    if (this.detail && this.detail.metadata) {
      _.forEach(
        _.filter(
          this.detail.metadata.medicationLongTerm,
          (item) => this.doTransformTextOther(item.isLongTerm),
        ),
        (item, index) => {
          const mapMedi = this.doTransformMedicationLongTerm(item, index + 1)
          if (mapMedi) {
            medicationLongTerm.push(mapMedi)
          }
        },
      )
    }
    return {
      title: 'การรับประทานยาต่อเนื่อง',
      icon: 'pill',
      data: medicationLongTerm,
    }
  }

  get specialCare() {
    const specialCare = []
    if (this.detail && this.detail.metadata) {
      _.forEach(
        _.filter(
          this.detail.metadata.specialCare,
          (item) => item.description,
        ), (item, index) => {
          specialCare.push(this.doTransformSpecialCare(item, index + 1))
        },
      )
    }
    return {
      title: 'การดูแลพิเศษ',
      icon: 'bed-empty',
      data: specialCare,
    }
  }

  get adlBarthelIndex() {
    return this.detail && this.detail.metadata
      ? {
          title: 'แบบประเมินความสามารถในการปฏิบัติกิจวัตรประจำวัน (ADL Barthel Index)',
          icon: 'file-document',
          data: _.filter([
            {
              text: '1. การรับประทานอาหาร (Feeding)',
              value: `${this.detail.metadata.adlBarthelIndexFeedingNo1} คะแนน`,
            },
            {
              text: '2. การเคลื่อนย้าย (Transfers)',
              value: `${this.detail.metadata.adlBarthelIndexTransfersNo2} คะแนน`,
            },
            {
              text: '3. การเดินการเคลื่อนไหว (Mobility)',
              value: `${this.detail.metadata.adlBarthelIndexMobilityNo3} คะแนน`,
            },
            {
              text: '4. การแต่งตัวสวมใส่เสื้อผ้า (Dressing)',
              value: `${this.detail.metadata.adlBarthelIndexDressingNo4} คะแนน`,
            },
            {
              text: '5. การอาบน้ำเช็คตัว (Bathing)',
              value: `${this.detail.metadata.adlBarthelIndexBathingNo5} คะแนน`,
            },
            {
              text: '6. สุขวิทยาส่วนบุคคล (Grooming)',
              value: `${this.detail.metadata.adlBarthelIndexGroomingNo6} คะแนน`,
            },
            {
              text: '7. การใช้ห้องสุขา หรือกระโถน (Toilet use)',
              value: `${this.detail.metadata.adlBarthelIndexToiletUseNo7} คะแนน`,
            },
            {
              text: '8. การควบคุมการถ่ายอุจจาระ (Bowels)',
              value: `${this.detail.metadata.adlBarthelIndexBowelsNo8} คะแนน`,
            },
            {
              text: '9. การควบคุมการถ่ายปัสสาวะ (Bladder)',
              value: `${this.detail.metadata.adlBarthelIndexBladderNo9} คะแนน`,
            },
            { text: '10. การขึ้นลงบันได (Stairs)', value: `${this.detail.metadata.adlBarthelIndexStairsNo10} คะแนน` },
          ], (item) => item.value !== '' && !_.includes(item.value, 'undefined')),
        }
      : {}
  }

  get complicationRate() {
    return this.detail && this.detail.metadata
      ? {
          title: 'อัตราการเกิดภาวะแทรกซ้อน',
          icon: 'heart-pulse',
          data: _.filter([
            { text: `
                <span class="grey--text text--darken-2 mr-3">แผลกดทับจากที่บ้าน</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.complicationRateNo1)} ${this.doTransformIconColor(this.detail.metadata.complicationRateNo1)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.complicationRateNo1)}</span>
              `,
            },
            { text: `
                <span class="grey--text text--darken-2 mr-3">ปอดบวม</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.complicationRateNo2)} ${this.doTransformIconColor(this.detail.metadata.complicationRateNo2)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.complicationRateNo2)}</span>
              `,
            },
            { text: `
                <span class="grey--text text--darken-2 mr-3">ติดเชื้อทางเดินปัสสาวะ</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.complicationRateNo3)} ${this.doTransformIconColor(this.detail.metadata.complicationRateNo3)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.complicationRateNo3)}</span>
              `,
            },
            { text: `
                <span class="grey--text text--darken-2 mr-3">ข้อติดแข็ง</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.complicationRateNo4)} ${this.doTransformIconColor(this.detail.metadata.complicationRateNo4)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.complicationRateNo4)}</span>
              `,
            },
            { text: `
                <span class="grey--text text--darken-2 mr-3">อารมณ์ซึมเศร้า</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.complicationRateNo5)} ${this.doTransformIconColor(this.detail.metadata.complicationRateNo5)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.complicationRateNo5)}</span>
              `,
            },
          ] , (item) => !item.value.includes('<span style="vertical-align: top;"></span>')),
        }
      : {}
  }

  get needCaregiver() {
    return this.detail && this.detail.metadata
      ? {
        title: 'ความต้องการการดูแลพิเศษจากนักบริบาลผู้สูงอายุ',
        icon: 'human-female-boy',
        data: [
            { text: `
                <span class="grey--text text--darken-2 mr-3">การทำความสะอาดแผล</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.needCaregiverWoundNo1)} ${this.doTransformIconColor(this.detail.metadata.needCaregiverWoundNo1)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.needCaregiverWoundNo1)}</span>
              `,
            },
            { text: `
                <span class="grey--text text--darken-2 mr-3">การป้องกันแผลกดทับ</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.needCaregiverPressureUlcersNo2)} ${this.doTransformIconColor(this.detail.metadata.needCaregiverPressureUlcersNo2)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.needCaregiverPressureUlcersNo2)}</span>
              `,
            },
            { text: `
                <span class="grey--text text--darken-2 mr-3">การใช้อ็อกซิเจน</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.needCaregiverOxygenNo3)} ${this.doTransformIconColor(this.detail.metadata.needCaregiverOxygenNo3)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.needCaregiverOxygenNo3)}</span>
              `,
            },
            { text: `
                <span class="grey--text text--darken-2 mr-3">การให้อาหารทางสายยาง</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.needCaregiverTubeFeedingNo4)} ${this.doTransformIconColor(this.detail.metadata.needCaregiverTubeFeedingNo4)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.needCaregiverTubeFeedingNo4)}</span>
              `,
            },
            { text: `
                <span class="grey--text text--darken-2 mr-3">การดูแลสายสวนปัสสาวะ</span>
              `,
              value: `
                <span class="mdi mdi-${this.doTransformIcon(this.detail.metadata.needCaregiverUrinaryCatheterCareNo5)} ${this.doTransformIconColor(this.detail.metadata.needCaregiverUrinaryCatheterCareNo5)}--text mr-1"/>
                <span style="vertical-align: top;">${this.doTransformText(this.detail.metadata.needCaregiverUrinaryCatheterCareNo5)}</span>
              `,
            },
          ],
      }
      : {}
  }

  get patientDetail() {
    const data = []
    if (!_.isEmpty(this.profile)) { data.push(this.profile) }
    // if (!_.isEmpty(this.patientHealthy)) { data.push(this.patientHealthy) }
    if (!_.isEmpty(this.physicalExamination)) { data.push(this.physicalExamination) }
    if (!(_.isEmpty(this.history) || _.isEmpty(this.history.data))) { data.push(this.history) }
    if (!(_.isEmpty(this.medicationLongTerm) || _.isEmpty(this.medicationLongTerm.data))) {
      data.push(this.medicationLongTerm)
    }
    if (!(_.isEmpty(this.specialCare) || _.isEmpty(this.specialCare.data))) {
      data.push(this.specialCare)
    }
    if (!_.isEmpty(this.adlBarthelIndex)) { data.push(this.adlBarthelIndex) }
    if (!(_.isEmpty(this.complicationRate) || _.isEmpty(this.complicationRate.data))) {
      data.push(this.complicationRate)
    }
    if (!_.isEmpty(this.needCaregiver)) { data.push(this.needCaregiver) }
    return data
  }

  private doConvertDate(date: string) {
    return moment(date).locale('th').add(543, 'year').format('DD MMMM YYYY')
  }

  private doTransformHistory(item, index) {
    const data = []
    if (item.disease) { data.push({ text: `${index}. โรคประจำตัวที่ยังรักษาอยู่`, value: item.disease }) }
    if (item.hospital) { data.push({ text: 'โรงพยาบาลที่ทำการรักษา', value: item.hospital }) }
    if (item.hospitalDistrict) { data.push({ text: 'อำเภอ', value: item.hospitalDistrict }) }
    if (item.hospitalProvince) { data.push({ text: 'จังหวัด', value: item.hospitalProvince }) }
    if (item.hospitalMobileNo) { data.push({ text: 'เบอร์โทรศัพท์', value: item.hospitalMobileNo }) }
    if (item.appointmentRound) {
      data.push({ text: 'ตารางนัดตรวจล่วงหน้าครั้งที่', value: item.appointmentRound })
      if (item.appointmentDate) { data.push({ text: 'วันที่', value: this.localeDate(item.appointmentDate) }) }
      if (item.appointmentTime) { data.push({ text: 'เวลา', value: `${item.appointmentTime} น.` }) }
    }
    return data
  }

  private doTransformMedicationLongTerm(item, index) {
    return {
      text: `<span class="grey--text text--darken-2 mr-3">${index}. ${item.medicineName}: </span>`,
      value: `
        <span class="mdi mdi-${this.doTransformIcon(item.isLongTerm)} ${this.doTransformIconColor(item.isLongTerm)}--text mr-1"/>
        <span style="vertical-align: top;">${this.doTransformTextOther(item.isLongTerm)}</span>
      `,
    }
    return {
      text: `
        <span class="grey--text text--darken-2 mr-3">${index}. ${item.medicineName}: </span>
        <span class="mdi mdi-${this.doTransformIcon(item.isLongTerm)} ${this.doTransformIconColor(item.isLongTerm)}--text mr-1"/>
        <span style="vertical-align: top;">${this.doTransformTextOther(item.isLongTerm)}</span>
      `,
    }
  }

  private doTransformSpecialCare(item, index) {
    return {
      text: `<span class="grey--text text--darken-2 mr-3">${index}. ${item.description}</span>`,
    }
  }

  private doTransformIconColor(value) {
    switch (value) {
      case 0:
      case '0': return 'red'
      case 1:
      case '1': return 'green'
      case -1:
      case '-1': return 'grey'
      default: return ''
    }
  }

  private doTransformIcon(value) {
    switch (value) {
      case 0:
      case '0': return 'close-circle-outline'
      case 1:
      case '1': return 'checkbox-marked-circle-outline'
      case -1:
      case '-1': return 'minus-circle-outline'
      default: return ''
    }
  }

  private doTransformText(value) {
    switch (value) {
      case 0:
      case '0': return 'ไม่มี'
      case 1:
      case '1': return 'มี'
      case -1:
      case '-1': return 'ไม่แน่ใจ'
      default: return ''
    }
  }

  private doTransformTextOther(value) {
    switch (value) {
      case 0:
      case '0': return 'ไม่ครบ'
      case 1:
      case '1': return 'ครบ'
      case -1:
      case '-1': return 'ไม่แน่ใจ'
      default: return ''
    }
  }
}
